import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46ac3820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip-concent-msg-box-wrap" }
const _hoisted_2 = { class: "tip-concent-msgbox-title-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "游戏设置", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_5 = { class: "msgbox-body-wrap" }
const _hoisted_6 = { class: "d-control" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "视频开关", -1))
const _hoisted_8 = { class: "on" }
const _hoisted_9 = { class: "off" }
const _hoisted_10 = { class: "indicator" }
const _hoisted_11 = { class: "d-control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "声音开关", -1))
const _hoisted_13 = { class: "on" }
const _hoisted_14 = { class: "off" }
const _hoisted_15 = { class: "indicator" }
const _hoisted_16 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "tip-concent-msg-box-root",
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: _normalizeClass(["switch", { ison: _ctx.videoIsOn }]),
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVideo && _ctx.toggleVideo(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.videoIsOn ? '' : ''), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.videoIsOn ? '' : ''), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.videoIsOn ? '开' : '关'), 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", {
            class: _normalizeClass(["switch", { ison: _ctx.soundEffectIsOn }]),
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSoundEffect && _ctx.toggleSoundEffect(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.soundEffectIsOn ? '' : ''), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.soundEffectIsOn ? '' : ''), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.soundEffectIsOn ? '开' : '关'), 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["prevent"]))
          }, "确定"),
          _createElementVNode("div", {
            class: "btn-cancel",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]))
          }, "取消")
        ])
      ])
    ])
  ]))
}